import * as Localization from 'expo-localization';

import { restartApp } from 'components/env-picker';
import { PROD_SUPPORTED_LANGUAGES } from 'state/intl/constants';
import { LANGUAGES, LOCALES } from 'state/intl/types';
import { isNative, regionEnum } from 'utils/environment';
import { SyncStorageKey, syncStorage } from 'utils/environment/sync-storage';

const DEFAULT_LANGUAGE = LANGUAGES.en;
let currentLanguage: LANGUAGES | null = null;

/** get the persisted language or returns the device language */
export function getLanguage(): LANGUAGES {
  if (currentLanguage) {
    return currentLanguage;
  }
  currentLanguage =
    (syncStorage.getString(SyncStorageKey.LANGUAGE) as LANGUAGES) ?? getDeviceLanguage();

  if (!PROD_SUPPORTED_LANGUAGES[currentLanguage]) {
    currentLanguage = DEFAULT_LANGUAGE;
  }
  return currentLanguage;
}

/** set the language. RESTARTS THE APP! (reloads web) */
export function setLanguageAndRestart(language: LANGUAGES) {
  syncStorage.setString(SyncStorageKey.LANGUAGE, language);

  if (isNative) {
    restartApp();
  } else {
    typeof window !== 'undefined' && window.location.reload();
  }
}

function getDeviceLanguage(): LANGUAGES {
  try {
    return (
      (Localization.getLocales()?.[0]?.languageCode?.toLowerCase() as LANGUAGES) ?? DEFAULT_LANGUAGE
    );
  } catch {
    return DEFAULT_LANGUAGE;
  }
}

export const getLocale = () => {
  return `${getLanguage()}-${regionEnum}` as LOCALES;
};
